/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl, imageUrl} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
  title?: string
  description?: string
  product?: any[]
}

const ListsWidget8: React.FC<Props> = ({className, title, description, product}) => {
  return (
    <div className='card card-xl-stretch mb-5 mb-xl-8'>
      {/* begin::Header */}
      <div className='card-header align-items-center border-0 mt-4'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bold text-dark'>{title}</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>{description}</span>
        </h3>
        {/* <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 />
        </div> */}
      </div>
      {/* end::Header */}
      {
        product!.map((e, i) => (
      <div className='card-body pt-3' key={i}>
      <div className='d-flex align-items-sm-center mb-7'>
       
        <div className='symbol symbol-60px symbol-2by3 me-4'>
          <div
            className='symbol-label'
            style={{backgroundImage: `url(${imageUrl(e.image[0].formats.thumbnail.url)})`}}
          ></div>
        </div>
        <div className='d-flex flex-row-fluid align-items-center flex-wrap my-lg-0 me-2'>
          <div className='flex-grow-1 my-lg-0 my-2 me-2'>
            <a href='#' className='text-gray-800 fw-bold text-hover-primary fs-6'>
              {e.name}
            </a>
             <span className='text-muted fw-semibold d-block pt-1'>{e.product_detail || e.description}</span>
          </div>
          <div className='d-flex align-items-center'>
            <div className='me-6'>
              <span className='text-gray-800 fw-bold'>{e.sold || e.redeemed}</span>
              {
                e.sold ? <span className='badge badge-light-success fs-8 fw-bold'>Packages</span> : <span className='badge badge-light-danger fs-8 fw-bold'>Voucher</span>
              }
              
            </div>
          </div>
        </div>
      </div>
    </div>
        ))
      }
    </div>
  )
}

export {ListsWidget8}
